<div fxLayout="column" fxFill>
  <mat-toolbar>
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
      <button mat-button [routerLink]="['../..']">
        <mat-icon class="material-icons">keyboard_backspace</mat-icon>
      </button>
      <mat-divider [vertical]="true"></mat-divider>
      <span>{{ 'appointment.appointmentDetails' | translate }}</span>
    </mat-toolbar-row>
  </mat-toolbar>

  <div fxFlex="grow">
    @if ((actionPending$ | async)) {
      <div fxLayout="column" fxFill fxLayoutAlign="center center">
        <mat-spinner></mat-spinner>
      </div>
    } @else {
      <div class="main-content">
        <form [formGroup]="appointmentForm" appReadOnlyWithoutPermission="ROLE_USER" (ngSubmit)="persistAppointment()">
          <mat-card appearance="outlined" class="content-section" fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="1rem">
            <div fxLayout="row" fxLayoutGap="2rem">
              <mat-form-field>
                <mat-label>{{ 'core.customer' | translate }}</mat-label>
                <input matInput placeholder="{{ 'core.customer' | translate }}" formControlName="customer">
              </mat-form-field>
              <div fxLayout="row" fxLayoutGap="2rem">
                <mat-form-field>
                  <mat-label>{{ 'appointment.date' | translate }}</mat-label>
                  <input matInput
                    [min]="today"
                    [matDatepicker]="picker"
                    formControlName="date"
                    >
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>{{ 'appointment.time' | translate }}</mat-label>
                  <input matInput type="time" formControlName="time">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="2rem">
              <mat-form-field>
                <mat-label>{{ 'appointment.address' | translate }}</mat-label>
                <input matInput type="text" formControlName="address" placeholder="{{ 'appointment.address' | translate }}">
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'appointment.participants' | translate }}</mat-label>
                <input matInput type="text" formControlName="participants" placeholder="{{ 'appointment.participants' | translate }}">
              </mat-form-field>
            </div>
            <div fxLayout="row">
              <mat-form-field>
                <mat-label>{{ 'appointment.note' | translate }}</mat-label>
                <textarea matInput
                  formControlName="note"
                  placeholder="{{ 'appointment.note' | translate }}"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="10"
                  cdkAutosizeMaxRows="5">
                </textarea>
              </mat-form-field>
            </div>
          </mat-card>
          <div fxLayout="row" fxLayoutAlign="end center" class="save-tour">
            <button mat-raised-button *ngxPermissionsOnly="['ROLE_USER']" color="accent" type="submit" [disabled]="appointmentForm.invalid">
              <mat-icon>done</mat-icon>
              {{ 'appointment.actions.persist' | translate }}
            </button>
          </div>
        </form>
      </div>
    }

  </div>
</div>
